import { z } from 'zod';
import { CopilotJobTitleModelEntry } from 'libs/end-to-end/src/types/databases/scheduling/copilot-model-by-job-title-config';
import { CopilotModelByJobTitleConfig } from 'libs/end-to-end/src/types/databases/scheduling/copilot-model-by-job-title-config';

export const HiringCopilotJobTitleModelEntry =
  CopilotJobTitleModelEntry.describe('HiringCopilotJobTitleModelEntry');

export type HiringCopilotJobTitleModelEntry = z.infer<
  typeof HiringCopilotJobTitleModelEntry
>;

export const HiringCopilotModelByJobTitleConfig =
  CopilotModelByJobTitleConfig.describe('HiringCopilotModelByJobTitleConfig');

export type HiringCopilotModelByJobTitleConfig = z.infer<
  typeof HiringCopilotModelByJobTitleConfig
>;
